/**
 * Size styles mapping
 * spacing values are in pixels (converted from Tailwind units: 1 unit = 0.25rem = 4px)
 */
export const sizeStyles = {
  xs: {
    node: "px-2 py-2 text-xs",
    icon: "xs" as const,
    bullet: 24,
    spacing: { x: 8, y: 8 }, // px-2 = 2 * 4px, py-2 = 2 * 4px
  },
  sm: {
    node: "px-3 py-2.5 text-sm",
    icon: "xs" as const,
    bullet: 28,
    spacing: { x: 12, y: 10 }, // px-3 = 3 * 4px, py-2.5 = 2.5 * 4px
  },
  md: {
    node: "px-4 py-3 text-base",
    icon: "sm" as const,
    bullet: 32,
    spacing: { x: 16, y: 12 }, // px-4 = 4 * 4px, py-3 = 3 * 4px
  },
};
